// src/utils/themeUtils.js
// Handles Light, Dark, and System theme preferences across web and mobile webview

export const THEME_STORAGE_KEY = "recipeai_theme_preference";

export const getStoredTheme = () => {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (saved === "light" || saved === "dark" || saved === "system") {
      return saved;
    }
  } catch (e) {}
  return "system";
};

export const getSystemPreference = () => {
  if (typeof window !== "undefined" && window.matchMedia) {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  return "light";
};

export const applyTheme = (theme) => {
  const effectiveTheme = theme === "system" ? getSystemPreference() : theme;
  const root = document.documentElement;

  if (effectiveTheme === "dark") {
    root.setAttribute("data-theme", "dark");
    root.classList.add("dark-theme");
    root.classList.remove("light-theme");
  } else {
    root.setAttribute("data-theme", "light");
    root.classList.add("light-theme");
    root.classList.remove("dark-theme");
  }

  // Update meta theme-color for iOS Safari / status bar
  const metaThemeColor = document.querySelector('meta[name="theme-color"]');
  if (metaThemeColor) {
    metaThemeColor.setAttribute("content", effectiveTheme === "dark" ? "#121417" : "#fbfbf9");
  }

  // Notify React Native WebView if present
  if (typeof window !== "undefined" && window.ReactNativeWebView) {
    try {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "THEME_CHANGED",
          theme: theme,
          effectiveTheme: effectiveTheme,
        })
      );
    } catch (e) {}
  }

  // Dispatch custom window event so all components can react if needed
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("recipeai-theme-changed", {
        detail: { theme, effectiveTheme },
      })
    );
  }

  return effectiveTheme;
};

export const setThemePreference = (theme) => {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch (e) {}
  return applyTheme(theme);
};

export const initTheme = () => {
  const current = getStoredTheme();
  applyTheme(current);

  // Listen for OS system theme changes
  if (typeof window !== "undefined" && window.matchMedia) {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = () => {
      const saved = getStoredTheme();
      if (saved === "system") {
        applyTheme("system");
      }
    };
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handler);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(handler);
    }
  }
};
